import React, { useEffect } from "react";
import config from "../../config";
import Header_nav from "./Header_nav";
import Sidebar from "./Sidebar";

const Header = ({ children }) => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  useEffect(() => {
    // Legacy CSS expects this class on body
    document.body.classList.add("pg-legacy");

    return () => {
      document.body.classList.remove("pg-legacy");
    };
  }, []);
  return (
    <>
      <aside class="sidebar" id="sidebar">
        <div class="s-logo">
          <a href="/index">
            <div class="s-logo-icon">K</div>
            <span class="s-logo-text">KalpCargo</span>
          </a>
        </div>

        <div class="sidebar-scroll">
          {/* <?php include('sidebar.php'); ?> */}
          <Sidebar />
        </div>

        <div class="s-footer">
          <div class="av">JD</div>
          <div class="s-footer-text">
            <div
              style={{
                fontWeight: 600,
                fontSize: "12px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {userData.full_name}
            </div>
            <div
              style={{
                fontSize: "10.5px",
                color: "var(--t3)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {userData.email}
            </div>
          </div>
          <i
            class="bi bi-chevron-bar-left s-footer-icon"
            style={{ color: "var(--t3)", fontSize: "13px", cursor: "pointer" }}
          ></i>
          <button
            class="s-expand-btn"
            id="sidebarExpand"
            title="Expand sidebar"
          >
            <i class="bi bi-chevron-bar-right"></i>
          </button>
        </div>
      </aside>

      <div className="main" id="main">
        <Header_nav />

        {children}
      </div>
    </>
  );
};

export default Header;
